// src/use-localstorage.ts
import { useEffect, useState } from "react";
import ms from "ms";

// src/isBrowser.ts
var isBrowser = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var isBrowser_default = isBrowser;

// src/use-localstorage.ts
function useLocalStorage(key, _options) {
  const options = {
    age: "7d",
    initialValue: void 0,
    prefix: "Prefix:",
    ..._options
  };
  const prefixKey = options.prefix + key;
  let storage;
  try {
    storage = isBrowser_default ? localStorage : void 0;
  } catch (err) {
    console.error(err);
  }
  const storageValue = storage == null ? void 0 : storage.getItem(prefixKey);
  const item = JSON.parse(storageValue || "{}");
  const [value, setValue] = useState(
    item.value || options.initialValue
  );
  const UpdateValue = (newValue) => {
    setValue(newValue);
    const data = {
      value: newValue,
      expireAt: Date.now() + ms(options.age)
    };
    try {
      storage == null ? void 0 : storage.setItem(prefixKey, JSON.stringify(data));
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    const storageValue2 = storage == null ? void 0 : storage.getItem(prefixKey);
    if (!storageValue2) {
      return;
    }
    const isExpire = Date.now() > JSON.parse(storageValue2).expireAt;
    if (isExpire) {
      storage == null ? void 0 : storage.removeItem(prefixKey);
      setValue(void 0);
    }
    const newValue = JSON.parse(storageValue2).value;
    if (JSON.stringify(value) !== JSON.stringify(newValue)) {
      setValue(newValue);
    }
  });
  return [value, UpdateValue];
}
export {
  useLocalStorage
};
//# sourceMappingURL=use-localstorage.mjs.map